import { FC } from 'react'
import db from 'mobile_web/modules/db'
import { useLiveQuery } from 'dexie-react-hooks'
import { BadgeContainer } from 'mytours-read-common'
import { ImageSizePreset } from '../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl } from '../../../common_lib/utils'
import badgeLockedImage from '../../../assets/badge-icon-locked.png'
import classNames from 'classnames'

interface BadgeCardProps {
	id: number
}

const BadgeCard: FC<BadgeCardProps & BadgeContainer.Actions> = ({ id, toggleBadgeModal }) => {
	const item = useLiveQuery(() => id && db.badges.where({ id }).first(), [id])
	const earnedBadges = useLiveQuery(() => db.recentlyEarnedBadges.toArray())
	const earned = id && earnedBadges?.find(item => item?.badge_id === id)

	const focalPoint = item?.badge_media_item?.file?.focal_point
	const crop = focalPoint && (focalPoint[0] !== 0.5 || focalPoint[1] !== 0.5)
	const imageSrc =
		item?.badge_media_item?.file
			? generateImageUrl(item.badge_media_item?.file, {
				imageSizePreset: ImageSizePreset.Grid,
				crop,
				focalPoint,
			})
			: badgeLockedImage
	const imageSrcSet =
		item?.badge_media_item?.file
			? generateImageSrcSet(item.badge_media_item?.file, {
				imageSizePreset: ImageSizePreset.Grid,
				crop,
				focalPoint,
			})
			: badgeLockedImage

	const handleClickBadge = () => {
		toggleBadgeModal(true, id, false, !!earned)
	}

	return (
		<div className="badge-card" onClick={handleClickBadge}>
			<div className={classNames("badge-card-image", {"badge-card-image--unearned": !earned})}>
				<img src={imageSrc} srcSet={imageSrcSet} alt="" />
			</div>
			<h4>{earned ? item?.earned_title : item?.unearned_title}</h4>
		</div>
	)
}

const BadgeComponent = BadgeContainer.default(BadgeCard)
export default BadgeComponent as any
